import { Injectable } from '@angular/core';
//import { FirebaseX } from '@awesome-cordova-plugins/firebase-x/ngx';
import { Platform } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  firebaseX;
  constructor( private platform: Platform) {
  //  this.firebaseX = new FirebaseX();
  }

  // Tracks a custom event in Firebase Analytics
  logEvent(name: string, properties: object) {
    // this.platform.ready().then(() => {
    //   this.firebaseX?.logEvent(name, properties); // Ex: "select_content", {content_type: "page_view", item_id: "home"}
    // });
  }

  // Tracks an 'screen_view' event in Firebase Analytics
  trackScreen(name: string) {
    // this.platform.ready().then(() => {
    //   if (this.platform.is('cordova')) {
    //     this.firebaseX?.setScreenName(name);
    //   }
    // });
  }

  logMediaEvent(properties: { contentType: 'audio' | 'video'; itemId: string }) {
    // this.platform.ready().then(() => {
    //   this.firebaseX?.logEvent('select_content', properties);
    // });
  }
}
